import InvestorsNew from './InvestorsNew'

export default InvestorsNew
